<template>
  <div class="shop-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="水木商城" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="product-category-list">
      <div v-if="categorySelected != 'all'" @click = "selectCategory('all')" class="product-category-item">全部</div>
      <div v-if="categorySelected == 'all'" class="product-category-item category-selected">全部</div>
      <div v-for="(category,index) in productCategoryList" @click = "selectCategory(index,category.id)" class="product-category-item" :class="{'category-selected': categorySelected == index}">{{category.name}}</div>
    </div>
    <div class="shop-tab-part">
      <div v-if="tabSelected == '0'" class="mine-middle-item tab-selected">销量</div>
      <div v-if="tabSelected != '0'" @click = "changeTab('0')" class="mine-middle-item">销量</div>
      <div  v-if="tabSelected == '1'" class="mine-middle-item tab-selected">好评</div>
      <div v-if="tabSelected != '1'" @click = "changeTab('1')" class="mine-middle-item">好评</div>
      <div  v-if="tabSelected == '2'" class="mine-middle-item tab-selected">热门</div>
      <div v-if="tabSelected != '2'" @click = "changeTab('2')" class="mine-middle-item">热门</div>
    </div>
    <mt-loadmore style="font-size:0.24rem;color: #aaaaaa;position: relative" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">
      <div class="shop-list" :class="{'change':!isHaveShop}">
        <div v-if="shopList.length>0" class="shop-item general-box-shadow" v-for="store in shopList" @click="toShopDetail(store.shopId,store.shopName,store.intro)">
          <img class="shop-logo" :src="imgUrl+store.shopLogo">
          <div class="shop-info">
            <div class="shop-name">{{store.shopName}}</div>
            <div class="shop-trade-info">
              <div class="item">
                <span class="label">订单数</span>
                <span>{{store.shopOrderNum}}</span>
              </div>
              <div class="item">
                <span class="label">交易数 </span>
                <span>{{store.shopTradeNum}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isHaveShop" class="black-page">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无相关店铺!</div>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl,shareIcon} from "../../config";
  import ProductService from '../../service/product/ProductService'
  import StoreShopService from '../../service/store/StoreShopService'
  import shareService from '../../service/share/ShareService'
  import storeService from '../../service/store/StoreService'

  export default {
    name: 'StoreShopList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        categorySelected:'all',
        categoryId:'',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        tabSelected:'0',
        sort:'',
        productCategoryList:[],
        shopList:[],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        keyword:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isHaveShop:false,
        storeId:'',
        storeName:''
      }
    },
    created(){
      this.storeId = this.$route.query.storeId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.loadStoreShopList();
      this.loadStoreInfo();
      this.loadProductCategoryList();
    },
    methods: {
      async loadProductCategoryList(){
        let {code,msg,data} = await ProductService.categoryList();
        if(code == '0'){
          this.productCategoryList = data.categories;
          console.info(this.productCategoryList)
        }else {
          Toast(msg);
        }
      },
      async loadStoreInfo(){
        let {code,msg,data} = await storeService.detail(this.storeId);
        if(code == '0'){
          this.storeName = data.name;
          this.initWechatShare();
        }else {
          Toast(msg);
        }
      },
      async loadStoreShopList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.shopList = [];
        }
        let {code,msg,data} = await StoreShopService.shopList(this.storeId,this.sort,this.categoryId,this.pageNo);
        if(code == '0'){
          for(let shop of data.result){
            if(shop.shopName.length>12){
              shop.shopName = shop.shopName.substring(0,12)+'...'
            }
            this.shopList.push(shop)
          }
          if(this.shopList.length !=0){
            this.isHaveShop = true
          } else {
            this.isHaveShop = false
          }
          this.allLoaded = this.pageNo < data.pageSize? false:true;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      changeTab(tab){
        this.tabSelected = tab;
        if(tab == '0'){
          this.sort = ''
        }else if(tab == '1'){
          this.sort = 'good_evaluate_ratio'
        }else if(tab == '2'){
          this.sort = 'popularity'
        }
        this.pageNo = 1;
        this.loadStoreShopList();
      },
      selectCategory(index,categoryId){
        this.categorySelected = index;
        this.categoryId = categoryId;
        this.pageNo = 1;
        this.loadStoreShopList();
      },
      loadBottom(){
        this.pageNo++;
        this.loadStoreShopList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      //跳转店铺详情
      toShopDetail(id,shopName,shopIntro){
        if(!!this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({url: '/pages/shop/detail/detail?storeId='+this.storeId+"&shopId="+id});
        }else {
          this.$router.push({name: 'StoreShopDetail', query: {storeId:this.storeId,shopId:id,shopName,shopIntro}})
        }
      },
      async initWechatShare(){
        let title = "水木商城" + this.storeName;// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  .shop-list-page{
    background-color: white;
    font-size: 0.32rem;
    color: #191818;
    .change{
      padding-left: 0;
    }
    .product-category-list{
      display: flex;
      flex-wrap: nowrap;
      height: 0.84rem;
      line-height: 0.84rem;
      margin-left: 0.3rem;
      overflow-x: scroll;
      color: #939599;
      border-bottom: solid 1px #e0dedc;
      .product-category-item{
        flex-shrink: 0;
        min-width: 0.8rem;
        max-width: 1.5rem;
        margin-right: 0.3rem;
      }
      .category-selected{
        font-size: 0.36rem;
        font-weight: 700;
        color: #191818;
      }
    }
    .shop-tab-part{
      display: flex;
      height: 0.7rem;
      line-height: 0.7rem;
      margin-left: 0.3rem;
      margin-bottom: 0.11rem;
      font-weight: 700;
      .mine-middle-item{
        margin-right: 0.29rem;
      }
      .tab-selected{
        color: #feac00;
      }
    }
    .shop-list{
      padding-left: 0.3rem;
      font-size: 0.36rem;
      color: #191818;
      font-weight: bold;
      .shop-item{
        display: flex;
        width: 6.9rem;
        height: 1.71rem;
        margin-bottom: 0.2rem;
        .shop-logo{
          width: 1.3rem;
          height: 1.3rem;
          margin: 0.2rem;
          border-radius: 0.06rem
        }
        .shop-info {
          padding-left: 0.12rem;
          .shop-name {
            padding: 0.2rem 0 0.25rem;
          }
          .shop-trade-info {
            display: flex;
            font-size: 0.27rem;
            .item {
              margin-right: 0.3rem;
              padding: 0.06rem 0.3rem;
              background-color: #e0dedc;
              border-radius: 20px;
              .label {
                font-size: 0.24rem;
                padding-right: 0.05rem;
              }
            }
          }
        }
      }
    }
  }
</style>
